export const LIST_TOOLS_REQUEST = 'LIST_TOOLS_REQUEST'
export const LIST_TOOLS_SUCCESS = 'LIST_TOOLS_SUCCESS'
export const LIST_TOOLS_FAIL = 'LIST_TOOLS_FAIL'

export const RESET_LANGUAGE_REQUEST = 'RESET_LANGUAGE_REQUEST'
export const RESET_LANGUAGE_SUCCESS = 'RESET_LANGUAGE_SUCCESS'
export const RESET_LANGUAGE_FAIL = 'RESET_LANGUAGE_FAIL'

export const RESET_STATUS_BY_ITEMS_REQUEST = 'RESET_STATUS_BY_ITEMS_REQUEST'
export const RESET_STATUS_BY_ITEMS_SUCCESS = 'RESET_STATUS_BY_ITEMS_SUCCESS'
export const RESET_STATUS_BY_ITEMS_FAIL = 'RESET_STATUS_BY_ITEMS_FAIL'

export const UPDATE_HEALTHCARE_REQUEST = 'UPDATE_HEALTHCARE_REQUEST'
export const UPDATE_HEALTHCARE_SUCCESS = 'UPDATE_HEALTHCARE_SUCCESS'
export const UPDATE_HEALTHCARE_FAIL = 'UPDATE_HEALTHCARE_FAIL'

export const UPDATE_EFORM_EXPIRED_LINK_REQUEST = 'UPDATE_EFORM_EXPIRED_LINK_REQUEST'
export const UPDATE_EFORM_EXPIRED_LINK_SUCCESS = 'UPDATE_EFORM_EXPIRED_LINK_SUCCESS'
export const UPDATE_EFORM_EXPIRED_LINK_FAIL = 'UPDATE_EFORM_EXPIRED_LINK_FAIL'

